import React from "react";
import "./SurveyOptions.scss";
import { useOverlayPopupOpen } from "../../hooks/use-overlay-popup-open";
interface SurveyOptionsProps {
  visible: boolean;
  title: string;
  primaryLabel: string;
  primaryDescription: string;
  secondaryLabel: string;
  secondaryDescription: string;
  onLive: () => void;
  onUpload: () => void;
}

export const SurveyOptions: React.FC<SurveyOptionsProps> = ({
  visible,
  title,
  primaryLabel,
  primaryDescription,
  secondaryLabel,
  secondaryDescription,
  onLive,
  onUpload,
}) => {
  useOverlayPopupOpen(visible);
  if (!visible) return null;

  return (
    <div className="survey-options-overlay">
      <div className="card-width survey-options-card">
        <h3 className="survey-options-title">{title}</h3>
        <div className="survey-options-list">
        <button
          onClick={onLive}
          className="survey-options-button survey-options-button--primary"
        >
          <span className="survey-options-icon">📹</span>
          <div className="survey-options-text">
            <div className="survey-options-label">{primaryLabel}</div>
            <div className="survey-options-description">
              {primaryDescription}
            </div>
          </div>
        </button>
        <button
          onClick={onUpload}
          className="survey-options-button survey-options-button--secondary"
        >
          <span className="survey-options-icon">📤</span>
          <div className="survey-options-text">
            <div className="survey-options-label">{secondaryLabel}</div>
            <div className="survey-options-description">
              {secondaryDescription}
            </div>
          </div>
        </button>
        </div>
      </div>
    </div>
  );
};

